import React, { useEffect } from 'react';
import { CertificatePaymentWrapper } from '@components';
import { scrollTop } from '@share/utils';
import styles from './styles.module.scss';

export const CertificatePaymentPage = (): React.ReactElement => {
  useEffect(() => {
    scrollTop();
  }, []);

  return (
    <div className={styles.root}>
      <CertificatePaymentWrapper />
    </div>
  );
};
